import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import GetStaticRoutes from "./routes/static-routes";
import PayPage from "./pages/static-pages/pay-page";
import { isPayHost } from "./utils/host";

function App() {
  // pay.* shows only the purchase page; every other host is the full site.
  if (isPayHost()) {
    return (
      <Routes>
        <Route path="/" element={<PayPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      {GetStaticRoutes()}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
